import React from 'react';
import {HomepageDialogs} from '../modules/HomepageDialogs';

export async function renderHPDialogs(root) {
    root.render(<HomepageDialogs />);
}
